module.exports = __webpack_public_path__ + "static/media/yuanhuan.02315d2b.jpg";